import * as React from 'react';

export const SUPERVISION_REFETCH_INTERVAL_IN_MILLISECONDS = 30_000;

/** Reads a supervision view again at a fixed interval; `refetch` must be stable or the interval restarts on every render. */
const useRefetchInterval = (refetch: () => void, intervalMs: number): void => {
	React.useEffect(() => {
		const intervalId = setInterval(refetch, intervalMs);

		return () => {
			clearInterval(intervalId);
		};
	}, [refetch, intervalMs]);
};

export default useRefetchInterval;
